<template>
  <div class="my_table">
    <el-table
    :data="
      tableData.filter(
        (data) =>
          !search ||
          data[Searchfield].toLowerCase().includes(search.toLowerCase())
      )
    "
    :style="'width: 100%;overflow: auto;height:' + height"
  >
    <el-table-column
      v-for="(item, index) in tableTitle"
      :label="item.label"
      :key="index"
      :prop="item.prop"
    >
    </el-table-column>
    <!-- <el-table-column label="Name" prop="name"> </el-table-column> -->
    <el-table-column align="left" v-if="operateShow">
      <template slot="header" slot-scope="scope">
        <!-- <el-input v-model="search" size="mini" placeholder="输入关键字搜索" /> -->
        操作
      </template>
      <template slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="查看"
          placement="top-start"
          v-if="viewShow"
        >
          <el-button
            size="mini"
            icon="el-icon-view"
            type="primary"
            @click="handleEdit(scope.$index, scope.row, '查看')"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top-start"
          v-if="modifyShow"
        >
          <el-button
            size="mini"
            icon="el-icon-edit"
            type="primary"
            @click="handleEdit(scope.$index, scope.row, '修改')"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="查看征信"
          placement="top-start"
          v-if="creditShow"
        >
          <el-button
            size="mini"
            icon="el-icon-view"
            type="warning"
            @click="handleEdit(scope.$index, scope.row, '征信')"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="确认已读"
          placement="top-start"
          v-if="readShow"
        >
          <el-button
            size="mini"
            icon="el-icon-s-claim"
            type="primary"
            @click="handleEdit(scope.$index, scope.row, '已读')"
          ></el-button>
        </el-tooltip>
        <!-- <el-button
          size="mini"
          type="danger"
          @click="handleDelete(scope.$index, scope.row)"
          >Delete</el-button
        > -->
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    propSearch: {
      type: String,
      default: "",
    },
    Searchfield: {
      type: String,
      default: "cname",
    },
    title: {
      type: String,
      default: "新增",
    },
    height: {
      type: String,
      default: "80vh",
    },
    creditShow: {
      type: Boolean,
      default: false,
    },
    viewShow: {
      type: Boolean,
      default: true,
    },
    modifyShow: {
      type: Boolean,
      default: true,
    },
    readShow: {
      type: Boolean,
      default: false,
    },
    operateShow:{
      type: Boolean,
      default: true,
    },
    tableTitle: {
      type: Array,
      default: () => {
        return [
          {
            label: "时间",
            prop: "date",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "地址",
            prop: "address",
          },
        ];
      },
      btnShow: {
        type: Object,
        default: () => {},
      },
    },
  },
  data() {
    return {
      // tableData: ,
      search: "",
      // tableTitle: [
      //   {
      //     label: '时间',
      //     prop: 'date'
      //   },
      //   {
      //     label: '姓名',
      //     prop: 'name'
      //   },
      //   {
      //     label: '地址',
      //     prop: 'address'
      //   }
      // ]
    };
  },
  created() {
    // console.log('测试传递的值',this.search)
  },
  methods: {
    handleEdit(index, row, type) {
      let data = {
        index: index,
        data: row,
        type: type,
      };
      this.$emit("detail", data);
    },
    handleDelete(index, row) {},
  },
  watch: {
    // 监测父级搜索框传过来的值
    propSearch: {
      handler(newdata, oldData) {
        this.search = newdata;
      },
    },
  },
};
</script>
<style lang="less" scoped>

.my_table > .el-table::before{
  /* 去除下边框 */
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/table_list/index.vue